module.exports = __webpack_public_path__ + "img/other02.26bba14b.png";